import api from './api';

/**
 * Create a tracking function configured with a particular "view" and "section".
 * Returned function accepts params for "identifier" and "extra_content", for
 * tracking individual events.
 *
 * @return  {Function}  function for tracking events
 */
export default (view, section) => {
  return (identifier = null, extra_content, type_id) => {
    const page = window.location.pathname;

    return api.track({
      identifier,
      page,
      view,
      section,
      type_id,
      extra_content,
    });
  }
}

export const createRecitTracker = (action, cxt_view, type_id) => {
  return (
      cxt_model,
      time,
      cxt_rec_id,
      cxt_page_load_id,
      cxt_synd_id,
      cxt_module,
      cxt_position,
      cxt_rec_item_id,
  ) => {
    api.track({
      action,
      time,
      cxt_view,
      cxt_model,
      cxt_rec_id,
      cxt_page_load_id,
      cxt_synd_id,
      cxt_module,
      cxt_position,
      cxt_rec_item_id,
      type_id,
    });
  }
}

export const eoyStatsTracker = (view, section) => {
  return (identifier = null, params, type_id) => {
    const page = window.location.pathname;
    const {owner, extra_int_data, cxt_item_position} = params

    return api.track({
      identifier,
      page,
      view,
      section,
      type_id,
      extra_int_data,
      cxt_item_position,
      extra_content: owner ? 'owner' : undefined
    });
  }
}

export const yirTracker = (view, section) => {
  return (
    identifier = null,
    type_id,
    extra_content
  ) => {
    const page = window.location.pathname
    const event = "pv_wt"

    return api.track({
      identifier,
      page,
      view,
      section,
      event,
      type_id,
      extra_content
    })
  }
}